import { createGlobalStyle } from 'styled-components';
import { lighten } from 'polished';

const GlobalStyle = createGlobalStyle`
  ${({ theme }) => `
    html {
      font-size: 62.5%;
    }

    body {
      font-family: noto-sans, verdana, helvetica-neue-lt-pro, sans-serif;
      font-weight: normal;
      font-style: normal;
      background-color: #f9fafb;
      margin: 0;
      position: relative;
    }

    a {
      color: ${theme.colours.primary};
      letter-spacing: 0.02px;
      text-decoration: underline;

      &:hover, &:focus {
        color: ${lighten(0.2, theme.colours.primary)};
      }
    }

    * {
      box-sizing: border-box;
    }
  `}
`;

export default GlobalStyle;
